// Utils
import handleNotification from 'utils/toast/handleNotification'
// Context and Constant
import WORDING from 'constants/wording'
import { useNavigate } from 'react-router-dom'
import Table from 'components/table'
import TableItem from 'components/TableItem'
import { tableItemButton } from 'constants/tableItem'

export default function CvuPanel({ userName }) {
  const { successToast } = handleNotification()
  const navigate = useNavigate()

  function onCopy() {
    navigator.clipboard.writeText(userName)
    successToast(WORDING.COPIADO)
  }

  return (
    <Table>
      <TableItem
        label='Alias'
        value={userName}
        buttonType={tableItemButton.COPY}
        onClick={() => onCopy()}
      />
      <TableItem
        value='Modificar mi alias'
        buttonType={tableItemButton.ARROW}
        onClick={() => navigate('/modificar-alias')}
      />
    </Table>
  )
}
